import { EventProperties, ValidationFields } from '@lentau/analytics/health-metrics/shared';

export function checkEmptyFields(fields: ValidationFields[]): EventProperties {
  return fields.reduce((acc: EventProperties, field: ValidationFields) => {
    const arrayEmptyField = Array.isArray(field.fieldToCheck) && !field.fieldToCheck.length;
    const noField = !field.fieldToCheck || arrayEmptyField;

    if (noField) {
      acc.push({ value: true, key: field.errorName });
    }

    return acc;
  }, []);
}
